"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NiceUiContentService = void 0;
class NiceUiContentService {
    constructor(opts) {
        this.root = opts.root;
    }
}
exports.NiceUiContentService = NiceUiContentService;
